import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbCardModule, NbTabsetModule } from '@nebular/theme';
import { ConsumptionTypeFilterComponent } from './consumption-type-filter/consumption-type-filter.component';
import { CashOutFiltersComponent } from '../cash-out-filters/cash-out-filters.component';
import { CashInFiltersComponent } from '../cash-in-filters/cash-in-filters.component';
import { EmissionFactorsDetailsComponent } from './emission-factors-details/emission-factors-details.component';
import { EnergyCarbonObjectivesComponent } from './energy-carbon-objectives/energy-carbon-objectives.component';
import { InflationHypothesisDetailsComponent } from './inflation-hypothesis-details/inflation-hypothesis-details.component';
import { Observable, of } from 'rxjs';
import { AsyncPipe } from '@angular/common';

export type EnergySettingsType = 'energyPrice' | 'energyObjectives' | 'carbonObjectives' | 'emissionFactors' | 'energyPayback' | 'consumptionType';

@Component({
  selector: 'app-energy-settings-dialog',
  styleUrls: ['./energy-settings-dialog.component.scss'],
  templateUrl: './energy-settings-dialog.component.html',
  standalone: true,
  imports: [
    NbCardModule,
    NbTabsetModule,
    InflationHypothesisDetailsComponent,
    EnergyCarbonObjectivesComponent,
    EmissionFactorsDetailsComponent,
    CashInFiltersComponent,
    CashOutFiltersComponent,
    ConsumptionTypeFilterComponent,
    TranslateModule,
    AsyncPipe,
  ],
})

export class EnergySettingsDialogComponent implements OnInit {

  public energyPriceTitle = this.translate.instant('Energy price');
  public energyObjectivesTitle = this.translate.instant('Energy objective');
  public carbonObjectivesTitle = this.translate.instant('Carbon objective');
  public emissionFactorsTitle = this.translate.instant('Emission factors');
  public energyPaybackTitle = this.translate.instant('Energy payback');
  public epEfTitle = this.translate.instant("Consumption parameters");
  public isFidji$: Observable<boolean> = of(false);
  public defaultSelectedTab: EnergySettingsType = 'energyObjectives';
  public initialized = false;
  public selectedTabId;

  constructor(
    private ref: NbDialogRef<EnergySettingsDialogComponent>,
    private translate: TranslateService,
  ) { }

  public ngOnInit(): void {}

  public changeTab(event): void {
    if (this.initialized) {
      this.defaultSelectedTab = null;
    }
    this.initialized = true;
    this.selectedTabId = Number(event.tabId);
  }

  public submit(): void {
    this.ref.close();
  }
}
